import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  rating: 'Good' | 'Average' | 'Poor';
  fixed: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TagScoreRating',
  props: {
    rating: null,
    fixed: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})